"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactHotLoader = require("react-hot-loader");

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _UserAdmin = _interopRequireDefault(require("../../containers/UserAdmin"));

/* eslint-disable no-eq-null */
function mapStateToProps(state) {
  return {
    user: state.auth.user
  };
}

const UserAdminScene = ({
  user = {
    access: []
  }
}) => {
  // HACK: This is to prevent a race condition between the session and the
  // permissions/portfolio request. This works because the id and access data is
  // set at the same time but separate to the session provider.
  if (user.id == null) return null;
  if (user.access != null && !user.access.includes('userAdmin')) return /*#__PURE__*/React.createElement(_reactRouterDom.Redirect, {
    to: "/404"
  });
  return /*#__PURE__*/React.createElement(_UserAdmin.default, null);
};

var _default = (0, _reactHotLoader.hot)(module)((0, _reactRedux.connect)(mapStateToProps)(UserAdminScene));

exports.default = _default;
module.exports = exports.default;